const router = require('./router');
const template = require('./anchor.tpl').default;

module.exports = DomClass(template, function Anchor() {
	var _t = this;

	this.__dom.href.onclick = function(evt) {
		var e = evt || window.event;
		e.preventDefault();
		_t.open();
		return false;
	};

	this.open = function() {
		router.navigate(this.href);
	};
});
